import { useState, useCallback } from 'react';

/**
 * useFiltersScreenUI - Custom Hook
 * 
 * Maneja el estado de la pantalla de filtros de manera optimizada
 * Evita problemas de re-renderizado y dependencias circulares
 * Simplificado para usar solo toggle cuando está abierto
 * 
 * @param {boolean} initialState - Estado inicial de la pantalla de filtros
 * @returns {Object} Estado y funciones para manejar la pantalla de filtros
 */
const useFiltersScreenUI = (initialState = false) => {
  const [showFiltersScreen, setShowFiltersScreen] = useState(initialState);

  // Toggle - cambia entre true/false
  const toggleFiltersScreen = useCallback(() => {
    setShowFiltersScreen(prev => !prev);
  }, []);

  return {
    // Estado
    showFiltersScreen,
    
    // Acciones
    toggleFiltersScreen,
    
    // Control directo (usar con cuidado)
    setShowFiltersScreen
  };
};

export default useFiltersScreenUI;
